import React, { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Camera, User } from 'lucide-react';
import { personalInfo } from '../data/portfolio';

// const STORAGE_KEY = 'portfolio-profile-image';

const ProfileImage = ({ size = 'lg' }) => {
  const [image, setImage] = useState(personalInfo.avatar || null);
  const [hovering, setHovering] = useState(false);
  const inputRef = useRef(null);

  const dimensions = {
    lg: { outer: 'w-40 h-40 md:w-80 md:h-80', ring: 'p-1', icon: 48, camera: 20 },
    sm: { outer: 'w-20 h-20', ring: 'p-0.5', icon: 28, camera: 14 },
  }[size];

  // Load saved image from localStorage on mount
  // useEffect(() => {
  //   const saved = localStorage.getItem(STORAGE_KEY);
  //   if (saved) setImage(saved);
  // }, []);

  // const handleFileChange = (e) => {
  //   const file = e.target.files?.[0];
  //   if (!file) return;
  //   const reader = new FileReader();
  //   reader.onload = (ev) => {
  //     const dataUrl = ev.target.result;
  //     setImage(dataUrl);
  //     localStorage.setItem(STORAGE_KEY, dataUrl);
  //   };
  //   reader.readAsDataURL(file);
  // };

 const [clicks, setClicks] = useState(0);
const resetTimerRef = useRef(null);

const handleClick = () => {
  setClicks((prev) => {
    const next = prev + 1;

    // Clear previous timer
    if (resetTimerRef.current) {
      clearTimeout(resetTimerRef.current);
    }

    // Start new reset timer (e.g., 2 seconds)
    resetTimerRef.current = setTimeout(() => {
      setClicks(0);
    }, 2000);

    return next;
  });
};

useEffect(() => {
  if (clicks === 5) {
    window.dispatchEvent(new Event("diagnostic-mode"));
    setClicks(0);
  }
}, [clicks]);

  return (
    <motion.div
  whileHover={{ scale: 1.03 }}
  transition={{ type: 'spring', stiffness: 200 }}
>
    <div
      className={`relative ${dimensions.outer} flex-shrink-0 cursor-pointer select-none`}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      onClick={() => inputRef.current?.click()}
    >
      {/* Outer animated ring */}
      <div
        className={`absolute inset-0 rounded-full ${dimensions.ring}`}
        style={{
          background: 'var(--gradient-primary)',
          padding: '2px',
          boxShadow: '0 8px 25px hsl(var(--primary) / 0.15)'
        }}
      >
        <div className="w-full h-full rounded-full bg-background" />
      </div>

      {/* Spinning dashed ring */}
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
        className="absolute inset-0 rounded-full pointer-events-none hidden dark:block"
        style={{
          background: 'transparent',
          border: '1px dashed hsl(var(--primary) / 0.25)',
          borderRadius: '50%',
          transform: 'scale(1.06)',
        }}
      />

      {/* Glow pulse */}
      <motion.div
        animate={{ opacity: [0.3, 0.7, 0.3], scale: [1, 1.05, 1] }}
        transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
        className="absolute inset-0 rounded-full pointer-events-none hidden dark:block"
        style={{
          boxShadow: '0 0 40px hsl(var(--primary) / 0.2)',
          borderRadius: '50%',
        }}
      />

      {/* Image / placeholder */}
      <div
        className="absolute inset-[3px] rounded-full overflow-hidden"
        style={{ background: 'hsl(var(--surface-2))' }}
        onClick={() => handleClick()}
      >
        {image ? (
          <img
            src={image}
            alt="Rajib Roy"
            className="w-full h-full object-cover"
            style={{
              // filter: hovering ? 'brightness(0.6)' : 'brightness(1)',
              transition: 'filter 0.2s ease',
            }}
          />
        ) : (
          <div
            className="w-full h-full flex items-center justify-center"
            style={{
              background: 'linear-gradient(135deg, hsl(var(--surface-2)), hsl(var(--surface-3)))',
            }}
          >
            <User size={dimensions.icon} style={{ color: 'hsl(var(--muted-foreground))' }} />
          </div>
        )}
      </div>
    </div>
    </motion.div>
  );
};

export default ProfileImage;
